import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("klus_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fileUrl = (path) =>
  `${API}/files/${path}?auth=${encodeURIComponent(localStorage.getItem("klus_token") || "")}`;

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "A apărut o eroare. Încearcă din nou.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}
